import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';
import { State } from '../../../dave-data-module/State';
import { getCustomerById } from '../../../dave-data-module/State/selectors/customers.selectors';
import { getDoctorsByCustomerId } from '../../../dave-data-module/State/selectors/mdqx/selectors';
import { Observable } from 'rxjs';
import { CustomerEntity } from '../../../dave-data-module/entities/customer.entity';
import { DoctorEntity } from '../../../dave-data-module/entities/mdqx/doctor/doctor.entity';

@Component({
    selector: 'app-doctor-list-card',
    templateUrl: './doctor-list-card.component.html',
    styleUrls: ['./doctor-list-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DoctorListCardComponent implements OnInit {
    @Input() CustomerId: number = null;
    Customer$: Observable<CustomerEntity>;
    ShownDoctorsList$: Observable<DoctorEntity[]>;
    constructor(private store: Store<State>) {}
    ngOnInit(): void {
        this.Customer$ = this.store.select(getCustomerById({id: this.CustomerId}));
        this.ShownDoctorsList$ = this.store.select(getDoctorsByCustomerId, this.CustomerId).pipe(
            map(v =>
                v.slice().sort((a, b) => {
                    if (a.Name?.toLowerCase() < b.Name?.toLowerCase()) {
                        return -1;
                    }
                    if (a.Name?.toLowerCase() > b.Name?.toLowerCase()) {
                        return 1;
                    }
                    return 0;
                }),
            ),
        );
    }
}
